import ContactDetails from "./ContactDetails";

export default function Footer() {
  return (
    <footer className="w-full border-t border-t-black bg-linear-to-b from-white to-gray-300 py-3">
      <div className="mx-auto flex gap-24 items-start justify-center p-4">
        <div className="flex flex-col items-center">
          <h3 className="font-serif mt-0">
            &copy;&nbsp;EVTCC {new Date().getFullYear()}
          </h3>
          <p className="font-serif italic">evtcc.org</p>
        </div>
        <ContactDetails />
      </div>
    </footer>
  );
}
